export const PAGE_SIZE = 20;

export const ALL_EVENT_TYPES = "__all_event_types__";

export const ALL_EVENT_ORGANIZERS =
  "__all_event_organizers__";

export const ALL_EVENT_LEVELS =
  "__all_event_levels__";

export const DATE_FILTERS = {
  ALL: "all",
  UPCOMING: "upcoming",
  TODAY: "today",
  PAST: "past",
};

export const DATE_FILTER_OPTIONS = [
  {
    value: DATE_FILTERS.ALL,
    label: "Toutes les périodes",
  },
  {
    value: DATE_FILTERS.UPCOMING,
    label: "À venir",
  },
  {
    value: DATE_FILTERS.TODAY,
    label: "Aujourd’hui",
  },
  {
    value: DATE_FILTERS.PAST,
    label: "Passés",
  },
];

export const DEFAULT_FILTERS = {
  search: "",
  type: ALL_EVENT_TYPES,
  organizer: ALL_EVENT_ORGANIZERS,
  level: ALL_EVENT_LEVELS,
  date: DATE_FILTERS.ALL,
  onlyWithConvocations: true,
};

